const shipmentDetails = {
  'shipmentDetails.shipmentDetails': 'Детали отгрузки',
  'shipmentDetails.updateShipmentStatus': 'Изменить статус отгрузки',
  'shipmentDetails.saveLogistics': 'Создать транспортную накладную',
  'shipmentDetails.updateLogistics': 'Редактировать транспортную накладную',

  'shipmentDetails.orderId': 'ID заказа',
  'shipmentDetails.shipmentId': 'ID отгрузки',
  'shipmentDetails.shipmentId.placeholder': 'Введите ID отгрузки',
  'shipmentDetails.shipmentMethod': 'Способ доставки',
  'shipmentDetails.shipmentDate': 'Дата отгрузки',
  'shipmentDetails.shipmentStatus': 'Статус отгрузки',
  'shipmentDetails.shipmentStatusName': 'Статус отправки',

  'shipmentDetails.recipientInfo': 'Данные получателя',
  'shipmentDetails.recipientName': 'Получатель',
  'shipmentDetails.phone': 'Контактный телефон',
  'shipmentDetails.postalCode': 'Почтовый индекс',
  'shipmentDetails.email': 'Электронная почта',
  'shipmentDetails.address': 'Адрес доставки',

  'shipmentDetails.logisticsList': 'Список транспортных документов',
  'shipmentDetails.logisticsList.trackingNumber': 'Трекинг-номер',
  'shipmentDetails.logisticsList.trackingNumber.placeholder': 'Введите трекинг-номер',
  'shipmentDetails.logisticsList.shipmentId': 'ID отгрузки',
  'shipmentDetails.logisticsList.carrierName': 'Перевозчик',
  'shipmentDetails.logisticsList.carrierName.placeholder': 'Введите название перевозчика',
  'shipmentDetails.logisticsList.deliveryStatus': 'Статус доставки',
  'shipmentDetails.logisticsList.shipmentDate': 'Дата отправки',
  'shipmentDetails.logisticsList.shipmentDate.placeholder': 'Выберите дату отгрузки',
  'shipmentDetails.logisticsList.estimatedArrival': 'Предполагаемая дата прибытия',
  'shipmentDetails.logisticsList.estimatedArrival.placeholder': 'Выберите ожидаемую дату',
  'shipmentDetails.logisticsList.actualArrival': 'Фактическая дата прибытия',
  'shipmentDetails.logisticsList.actualArrival.placeholder': 'Выберите фактическую дату',
  'shipmentDetails.logisticsList.shipper': 'Отправитель',
  'shipmentDetails.logisticsList.shipper.placeholder': 'Введите имя отправителя',
  'shipmentDetails.logisticsList.contact': 'Контактные данные',
  'shipmentDetails.logisticsList.contact.placeholder': 'Введите контактную информацию',
  'shipmentDetails.logisticsList.trackingRecords': 'История перемещений',
  'shipmentDetails.logisticsList.update': 'Обновить',

  'shipmentDetails.trackingRecords.trackingTime': 'Время отслеживания',
  'shipmentDetails.trackingRecords.trackingLocation': 'Местоположение',
  'shipmentDetails.trackingRecords.remark': 'Примечание',
  'shipmentDetails.trackingRecords.attachment': 'Вложение',
  'shipmentDetails.trackingRecords.update': 'Обновить трекинг',
  'shipmentDetails.trackingRecords.location': 'Локация',
  'shipmentDetails.trackingRecords.location.placeholder': 'Укажите местоположение',
  'shipmentDetails.trackingRecords.time': 'Время',
  'shipmentDetails.trackingRecords.time.placeholder': 'Выберите время',

  'shipmentDetails.productList': 'Список отгруженных товаров',
};

export default shipmentDetails;
